import { render, staticRenderFns } from "./CommissionDocuments.vue?vue&type=template&id=6fd3b374&scoped=true&lang=pug&"
import script from "./CommissionDocuments.vue?vue&type=script&lang=ts&"
export * from "./CommissionDocuments.vue?vue&type=script&lang=ts&"
import style0 from "./CommissionDocuments.vue?vue&type=style&index=0&id=6fd3b374&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd3b374",
  null
  
)

export default component.exports